/**
 * Per-session stats strip — 3 tiles (today's accuracy / current streak /
 * best streak). Same shape across every quiz; extracted to one place so
 * a styling tweak hits all 17 routes at once.
 */

import { type SessionStats, accuracyPct } from "@/features/quiz/lib/common";

export function SessionStatsRow({ stats }: { stats: SessionStats }) {
  const pct = accuracyPct(stats);
  return (
    <div className="grid grid-cols-3 gap-3 text-center">
      <StatTile
        label="Today"
        value={`${stats.correct} / ${stats.attempts}`}
        sub={stats.attempts === 0 ? "–" : `${pct}%`}
      />
      <StatTile label="Streak" value={String(stats.streak)} sub="current" />
      <StatTile label="Best" value={String(stats.bestStreak)} sub="this session" />
    </div>
  );
}

function StatTile({ label, value, sub }: { label: string; value: string; sub: string }) {
  return (
    <div className="rounded-xl border border-border bg-surface p-3">
      <div className="text-[10px] uppercase tracking-wider text-text-muted">{label}</div>
      <div className="text-xl font-bold text-text mt-1">{value}</div>
      <div className="text-[10px] text-text-muted mt-0.5">{sub}</div>
    </div>
  );
}
